// Editor header component with logo and New Session button
import React from 'react';
import { Flex, HStack, VStack, Box, Text, Button } from '@chakra-ui/react';
import { Image as ImageIcon, RotateCcw } from 'lucide-react';

interface EditorHeaderProps {
  onReset: () => void;
}

export const EditorHeader: React.FC<EditorHeaderProps> = ({ onReset }) => {
  return (
    <Flex justify="space-between" align="center" pb={2}>
      <HStack spacing={3}>
        <Box p={2} bg="brand.primary.shade" borderRadius="lg">
          <ImageIcon size={24} color="#A71C29" />
        </Box>
        <VStack align="start" spacing={0}>
          {/* <Text fontSize="xl" fontWeight="bold" color="text.primary" fontFamily="primary">
            Image Optimizer
          </Text> */}
          <Text fontSize="sm" color="text.secondary" fontFamily="secondary">
            Compress • Crop • Convert
          </Text>
        </VStack>
      </HStack>
      <Button
        leftIcon={<RotateCcw size={16} />}
        bg="brand.primary.DEFAULT"
        color="white"
        _hover={{ bg: 'brand.primary.hover' }}
        onClick={onReset}
        fontFamily="secondary"
      >
        New Session
      </Button>
    </Flex>
  );
};
